"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const icons_1 = require("@ant-design/icons");
const antd_1 = require("antd");
const Form_1 = require("antd/lib/form/Form");
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const response_codes_1 = require("../../../../../assets/constants/response_codes");
const strings_1 = require("../../../../../assets/strings/strings");
const colors_1 = __importDefault(require("../../../../../assets/styles/colors"));
const user_requests_1 = require("../../../../../dataSource/user_requests");
const RoutesPaths_1 = require("../../../../../routes/RoutesPaths");
const logoutUser_1 = require("../../../../../utils/logoutUser");
const message_utils_1 = __importDefault(require("../../../../../utils/message_utils"));
const users_1 = require("../../../../../utils/users");
const PerfilStyles_1 = require("../../PerfilStyles");
const PersonalInformationsStyles_1 = require("../personalInformations/PersonalInformationsStyles");
require("./PrivacyNContactStyles.scss");
const Telephone_1 = __importDefault(require("../../../../../components/telephone/Telephone"));
const PrivacyNContact = ({ user, form: parentForm }) => {
    const [form] = (0, Form_1.useForm)();
    const history = (0, react_router_dom_1.useHistory)();
    const location = (0, react_router_dom_1.useLocation)();
    const handleSubmit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const params = {
            email: form.getFieldValue('email')
        };
        const response = yield (0, user_requests_1.editMyEmail)(params);
        const lastUrl = location.pathname + location.search;
        (0, users_1.setLastPageBeforeLogin)(lastUrl);
        if (response.code === response_codes_1.EditMyProfileCodes.success.EMAIL_CHANGED) {
            (0, users_1.removeUserFromStorage)();
            antd_1.Modal.confirm({
                cancelButtonProps: { style: { display: 'none' } },
                title: strings_1.EditMyProfileMessages.dataUpdatedSuccessfully,
                content: strings_1.EditMyProfileMessages.checkEmailAndLoginAgain,
                cancelText: 'cancel',
                autoFocusButton: null,
                icon: react_1.default.createElement(icons_1.CheckCircleTwoTone, { twoToneColor: colors_1.default.success }),
            });
            history.push(RoutesPaths_1.routesPaths.login);
        }
        else if (response.code === response_codes_1.EditMyProfileCodes.success.EMAIL_NOT_CHANGED) {
            message_utils_1.default.success({ message: strings_1.EditMyProfileMessages.dataUpdatedSuccessfully });
            history.push(RoutesPaths_1.routesPaths.root);
        }
        else {
            switch (response.code) {
                case response_codes_1.EditMyProfileCodes.error.EMAIL_ALREADY_IN_USE:
                    message_utils_1.default.error({
                        message: strings_1.EditMyProfileMessages.errorUpdatingData,
                        description: `${strings_1.EditMyProfileMessages.emailAlreadyInUse1Of2} ${params.email} ${strings_1.EditMyProfileMessages.emailAlreadyInUse2Of2}`,
                    });
                    break;
                case response_codes_1.EditMyProfileCodes.UNAUTHORIZED:
                    (0, logoutUser_1.handleLogout)(history, RoutesPaths_1.routesPaths.login);
                    message_utils_1.default.error({ message: 'Sessão Expirada' });
                    break;
                case response_codes_1.EditMyProfileCodes.error.EMAIL_TOKEN_NOT_FOUND:
                    (0, logoutUser_1.handleLogout)(history, RoutesPaths_1.routesPaths.login);
                    message_utils_1.default.error({ message: 'Faça o login novamente para trocar o e-mail' });
                    break;
                default:
                    message_utils_1.default.error({ description: strings_1.EditMyProfileMessages.errorUpdatingData });
                    break;
            }
        }
    }), [form, history, location]);
    (0, react_1.useEffect)(() => {
        var _a, _b;
        const tmpOffers = [];
        user.whatsappOffers && tmpOffers.push('whatsapp');
        user.emailOffers && tmpOffers.push('email');
        user.allowStoreData && tmpOffers.push('allowStore');
        //user. adicionar allowStore
        form.setFieldsValue({
            email: user.email,
        });
        let ddi;
        let phoneNumber;
        let landLinePhoneDdi;
        let landLinePhone;
        const telephone = (user === null || user === void 0 ? void 0 : user.telephone) ? (_a = user === null || user === void 0 ? void 0 : user.telephone) === null || _a === void 0 ? void 0 : _a.split('#') : [];
        if (telephone.length === 2) {
            [ddi, phoneNumber] = telephone;
        }
        else {
            ddi = '55';
            phoneNumber = (user === null || user === void 0 ? void 0 : user.telephone) ? user === null || user === void 0 ? void 0 : user.telephone.replace(/\D/g, '') : '';
        }
        const landLine = (user === null || user === void 0 ? void 0 : user.landLinePhone) ? (_b = user === null || user === void 0 ? void 0 : user.landLinePhone) === null || _b === void 0 ? void 0 : _b.split('#') : [];
        if (landLine.length === 2) {
            [landLinePhoneDdi, landLinePhone] = landLine;
        }
        else {
            landLinePhoneDdi = '55';
            landLinePhone = (user === null || user === void 0 ? void 0 : user.landLinePhone) ? user === null || user === void 0 ? void 0 : user.landLinePhone.replace(/\D/g, '') : '';
        }
        parentForm.setFieldsValue({
            ddi,
            phoneNumber,
            landLinePhoneDdi,
            landLinePhone,
            offers: tmpOffers,
        });
    }, [user, form, parentForm]);
    return (react_1.default.createElement("div", { id: "PrivacyNContact" },
        react_1.default.createElement(PerfilStyles_1.Text, { decoration: "500", size: 26, id: "mobile-title" }, "Contato & Privacidade"),
        react_1.default.createElement(PerfilStyles_1.Text, { id: "mobile-privacy-subtitle" }, "Mantenha seus contatos atualizados para receber informa\u00E7\u00F5es das suas reservas e ofertas exclusivas."),
        react_1.default.createElement(antd_1.Form, { id: "form-email", form: form, onFinish: handleSubmit },
            react_1.default.createElement(PerfilStyles_1.Group, { wrapper: true, style: { flexDirection: 'column' } },
                react_1.default.createElement(PerfilStyles_1.Text, null, "E-mail *"),
                react_1.default.createElement(PerfilStyles_1.GridRow, { id: "email" },
                    react_1.default.createElement(antd_1.Form.Item, { name: "email", rules: [{ type: 'email', message: 'Não é um formato de email válido!' }] },
                        react_1.default.createElement(PerfilStyles_1.InputStyled, null)),
                    react_1.default.createElement(antd_1.Button, { id: "update-email", size: "large", type: "primary", htmlType: "submit" }, "Alterar Email")))),
        react_1.default.createElement(antd_1.Form, { form: parentForm },
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(PerfilStyles_1.Group, null,
                    react_1.default.createElement(PerfilStyles_1.Text, null, "Telefone Fixo "),
                    react_1.default.createElement(Telephone_1.default, { form: parentForm, type: "telephone", ddiFieldName: "landLinePhoneDdi", ddiFormItemProps: {
                            initialValue: '55',
                            name: 'landLinePhoneDdi',
                        }, phoneFieldName: "landLinePhone", phoneFormItemProps: {
                            label: '',
                            name: 'landLinePhone',
                        }, phoneInputProps: {
                            placeholder: '(XX) XXXX-XXXX',
                        } })),
                react_1.default.createElement(PerfilStyles_1.Group, null,
                    react_1.default.createElement(PerfilStyles_1.Text, null, "Celular"),
                    react_1.default.createElement(Telephone_1.default, { form: parentForm, ddiFieldName: "ddi", ddiFormItemProps: {
                            initialValue: '55',
                            name: 'ddi',
                        }, phoneFieldName: "phoneNumber", phoneFormItemProps: {
                            label: '',
                            name: 'phoneNumber',
                        }, phoneInputProps: {
                            placeholder: '(XX) XXXXX-XXXX',
                        } }))),
            react_1.default.createElement("div", { className: "offers" },
                react_1.default.createElement(PerfilStyles_1.Text, null, "Como prefere receber nossas comunica\u00E7\u00F5es? Pode selecionar mais de uma op\u00E7\u00E3o:"),
                react_1.default.createElement(PersonalInformationsStyles_1.StyledFormItem, { name: "offers" },
                    react_1.default.createElement(PerfilStyles_1.CheckboxStyled.Group, null,
                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, { value: "whatsapp" }, "Quero receber atualiza\u00E7\u00F5es dos meus pedidos por WhatsApp."),
                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, { value: "email" }, "Quero receber ofertas, promo\u00E7\u00F5es exclusivas, cupons e novidades por e-mail."),
                        react_1.default.createElement(PerfilStyles_1.CheckboxStyled, { value: "allowStore" }, "Eu permito que a 360 Su\u00EDtes armazene e processe meus dados pessoais.")))))));
};
exports.default = PrivacyNContact;
